module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABDUlEQVQ4T53UsU4CQRAG4P/vbH04HsBiJxYUarQgMbESSCSRUBgz11HCu9kCNmP2whE4dm9nveqSu/tyM/PvUETWAEYAJqq6xD+uEMI9ySmADUVkB+AmOmb20jTNosYUkbGZrUjSzH4j+ADgs0Nq0HPs+P2E8SaE8EzyowZNYK+q+t6CtWgOi84J9KJD2BVYQktYEsyhJPfdNI9danvWT8RFyecPE4OyGI0hLPuHuUGVsCKY6Fkx/NmSU5gnp0kwNU0zO3jCfwUORcNzoi5AT85K6An0YJ5j2oI1WAllXI4Avjyh7Z+KfvkAnuI+/AFw6wltavH20EMEv83sjuSbqs5rtnX3rog8ApgB2P4BsfECYiqzkqYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/close.png
// module id = xp5Z
// module chunks = 91